import { render, staticRenderFns } from "./PrinterLandingPage.vue?vue&type=template&id=13dd5174&scoped=true"
import script from "./PrinterLandingPage.vue?vue&type=script&lang=js"
export * from "./PrinterLandingPage.vue?vue&type=script&lang=js"
import style0 from "./PrinterLandingPage.vue?vue&type=style&index=0&id=13dd5174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd5174",
  null
  
)

export default component.exports